import React from 'react';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { makeStyles } from '@material-ui/core';
import { BodyM } from 'components/Typography/Typography';
import styles from 'assets/jss/material-dashboard-pro-react/components/chargeBannerStyles';

interface IChargeBanner {
	value: string;
}

const ChargeBanner = ({ value }: IChargeBanner) => {
	const useStyles = makeStyles(styles);
	const classes = useStyles();
	return (
		<div className={classes.chargeBannerWrapper}>
			<div className={classes.infoMessageContainer}>
				<div className={classes.infoiconWrapper}>
					<InfoOutlinedIcon className={classes.infoIcon}/>
				</div>
				<div className={classes.messageWrapper}>
					<BodyM disableMargin>{value}</BodyM>
				</div>
			</div>
		</div>
	);
};

export default ChargeBanner;
